
import React from 'react';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import AjaxPromises from '../../../utils/AjaxPromises';
import UserStore from '../../../stores/UserStore';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';

export default class Popup extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emailAddress: props.guest.Email || '',
            cellPhone: props.guest.CellPhone || '',
            firstName: props.guest.FirstName || '',
            lastName: props.guest.LastName || '',
            streetAddress: (props.guest.address || {}).street || '',
            city: (props.guest.address || {}).city || '',
            state: (props.guest.address || {}).state || '',
            postalCode: (props.guest.address || {}).postal_code || '',
            registered: false,
        };
    }

    signup() {
        this.setState({ loading: true });
        AjaxPromises.POST(PosEndPoints.REGISTER_CUSTOMER_FOR_LOYALTY, UserStore.getApiData({
            AcctId: this.props.guest.Guest_id,
            CellPhone: this.state.cellPhone,
            FirstName: this.state.firstName,
            LastName: this.state.lastName,
            EmailAddress: this.state.emailAddress,
            StreetAddress: this.state.streetAddress,
            City: this.state.city,
            State: this.state.state,
            PostalCode: this.state.postalCode,
        })).then(res => {
            var message = 'Text message sent';
            if(!res.Result) {
                message = 'Text message failed to send';
            }
            else {
                this.setState({ cellPhone: '' });
            }
            NotificationActions.addNotification({
                type : res.Result ? 'success' : 'error',
                body : message
            });            
            if(res.Result) {
                PopupActions.close();
            }
        })
        .catch(() => {
            this.setState({ loading: false, registered: true });
        });   
    }

    render() {
        const inputStyle = {
            padding: '12px 15px',
            background: '#f8f8f8',
            borderRadius: 5,
            marginBottom: 10,
            marginRight: 30,
            fontSize: 16,
            width: 300
        };

        return(
            <div className='popup popup__transparent'>
                <div className='popup__content' style={{ width: 750, height: 600 }}>
                    <div className='popup-header'>
                        Loyalty Registration
                        <div
                            className='popup-close'
                            onClick={() => { PopupActions.close(); }}>
                            <i className='fa fa-times' aria-hidden='true' />
                        </div>
                    </div>

                    <div className='' style={{ height: 200, marginLeft: 20, padding: 30 }}>
                        <div className='row'>
                            <input
                                type='text'
                                placeholder='First Name'
                                value={this.state.firstName}
                                onChange={(e) => { 
                                    this.setState({ firstName : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10 })}                            
                            />
                            <input
                                type='text'
                                placeholder='Last Name'
                                value={this.state.lastName}
                                onChange={(e) => { 
                                    this.setState({ lastName : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10 })}                            
                            />
                        </div>

                        <div className='row'>
                            <input
                                type='text'
                                placeholder='Email Address'
                                value={this.state.emailAddress}
                                onChange={(e) => { 
                                    this.setState({ emailAddress : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10 })}                            
                            />
                            <input
                                type='text'
                                placeholder='Cell Phone #'
                                value={this.state.cellPhone}
                                onChange={(e) => { this.setState({ cellPhone : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10 })}
                            />
                        </div>
                        <div className='row'>
                            <input
                                type='text'
                                placeholder='Street Address'
                                value={this.state.streetAddress}
                                onChange={(e) => { 
                                    this.setState({ streetAddress : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10, width: 630 })}                            
                            />
                        </div>
                        <div className='row'>
                            <input
                                type='text'
                                placeholder='City'
                                value={this.state.city}
                                onChange={(e) => { 
                                    this.setState({ city : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10 })}                            
                            />
                            <input
                                type='text'
                                placeholder='State'
                                value={this.state.state}
                                onChange={(e) => { 
                                    this.setState({ state : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10, width: 75})}                            
                            />
                            <input
                                type='text'
                                placeholder='Postal Code'
                                value={this.state.postalCode}
                                onChange={(e) => { 
                                    this.setState({ postalCode : e.target.value }); }} 
                                style={Object.assign({}, inputStyle, { top: 10, width: 195 })}                            
                            />
                        </div>

                        <div className='row' style={{ marginLeft: -35 }}>
                            <div
                            
                                className={'btn-green delivery-options__save '}
                                onClick={() => this.signup()}
                   
                            >
                                { !this.state.loading ? 'Sign Up' : <i className="fa fa-spinner fa-pulse" aria-hidden="true" /> }
                            </div>                            
                        </div>
                        <div className='row'>
                            By clicking sign up, you are agreeing to share your information, including information from your state issued ID to receive marketing and loyalty messages from this facility. 
                            You may opt out at anytime of marketing messages via unsubscribe links in email and by replying STOP to text messages.
                        </div>
                    </div>
                </div>
            </div>                
        );
    }
}


// WEBPACK FOOTER //
// ./ui_src/app/components/popup/loyaltyRegistration/LoyaltyRegistration.react.jsx